<template>
  <div class="contributor panel panel-default">
    <div class="panel-heading">
      <h3>
        {{ lang.get('entries.form.contributor.label') }} #{{ counter }}
        <a
          v-if="canDelete && !locked"
          class="delete-contributor"
          @click.prevent="
            deleteContributor({ tabId: tab.id, contributorId: contributor.id })
          "
        >
          {{ lang.get('entries.form.delete-contributor') }}
        </a>
      </h3>
    </div>
    <div class="panel-body">
      <div v-if="noContributorFields">
        {{ lang.get('entries.form.no-contributor-fields') }}
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  inject: ['lang'],
  props: {
    contributor: {
      type: Object,
      required: true
    },
    tab: {
      type: Object,
      required: true
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    counter: {
      type: Number,
      required: true
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('entryForm', ['contributorFields']),
    noContributorFields() {
      return this.contributorFields(this.tab.id).length === 0;
    }
  },
  methods: {
    ...mapMutations('entryForm', ['deleteContributor'])
  }
};
</script>
